import img1 from "./WhatsApp Image 2025-11-27 at 6.30.17 AM.jpeg";
import img2 from "./WhatsApp Image 2025-11-27 at 6.30.20 AM (1).jpeg";
import img3 from "./WhatsApp Image 2025-11-27 at 6.30.20 AM (2).jpeg";
import img4 from "./WhatsApp Image 2025-11-27 at 6.30.20 AM (3).jpeg";
import img5 from "./WhatsApp Image 2025-11-27 at 6.30.20 AM.jpeg";
import img6 from "./WhatsApp Image 2025-11-27 at 6.30.21 AM.jpeg";
import img7 from "./WhatsApp Image 2025-11-27 at 6.30.22 AM (1).jpeg";
import img8 from "./WhatsApp Image 2025-11-27 at 6.30.22 AM.jpeg";
import img9 from "./WhatsApp Image 2025-11-27 at 6.30.23 AM (1).jpeg";
import img10 from "./WhatsApp Image 2025-11-27 at 6.30.23 AM (2).jpeg";
import img11 from "./WhatsApp Image 2025-11-27 at 6.30.23 AM.jpeg";
import img12 from "./WhatsApp Image 2025-11-27 at 6.30.24 AM (1).jpeg";
import img13 from "./WhatsApp Image 2025-11-27 at 6.30.24 AM (2).jpeg";
import img14 from "./WhatsApp Image 2025-11-27 at 6.30.24 AM.jpeg";
import img15 from "./WhatsApp Image 2025-11-27 at 6.30.25 AM.jpeg";
import img16 from "./WhatsApp Image 2025-11-27 at 6.30.26 AM (1).jpeg";
import img17 from "./WhatsApp Image 2025-11-27 at 6.30.26 AM.jpeg";
import img18 from "./WhatsApp Image 2025-11-27 at 6.30.27 AM.jpeg";
import img19 from "./WhatsApp Image 2025-11-27 at 6.30.28 AM (1).jpeg";
import img20 from "./WhatsApp Image 2025-11-27 at 6.30.28 AM (2).jpeg";
import img21 from "./WhatsApp Image 2025-11-27 at 6.30.28 AM.jpeg";
import img22 from "./WhatsApp Image 2025-11-27 at 6.30.29 AM (1).jpeg";
import img23 from "./WhatsApp Image 2025-11-27 at 6.30.29 AM (2).jpeg";
import img24 from "./WhatsApp Image 2025-11-27 at 6.30.29 AM.jpeg";
import img25 from "./WhatsApp Image 2025-11-27 at 6.30.30 AM (1).jpeg";
import img26 from "./WhatsApp Image 2025-11-27 at 6.30.30 AM (2).jpeg";
import img27 from "./WhatsApp Image 2025-11-27 at 6.30.30 AM.jpeg";
import img28 from "./WhatsApp Image 2025-11-27 at 6.30.31 AM (1).jpeg";
import img29 from "./WhatsApp Image 2025-11-27 at 6.30.31 AM (2).jpeg";
import img30 from "./WhatsApp Image 2025-11-27 at 6.30.31 AM (3).jpeg";
import img31 from "./WhatsApp Image 2025-11-27 at 6.30.31 AM.jpeg";
import img32 from "./WhatsApp Image 2025-11-27 at 6.30.32 AM (1).jpeg";
import img33 from "./WhatsApp Image 2025-11-27 at 6.30.32 AM.jpeg";

export default [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
  img21,
  img22,
  img23,
  img24,
  img25,
  img26,
  img27,
  img28,
  img29,
  img30,
  img31,
  img32,
  img33,
];
